import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-materialize";
import Html from "../../../utils/Html";

export default function RecipModalRemove({
  data,
  handleEvents,
}) {
  let header = "Bulk remove";
  let content = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.width = "400px";
  // modalCSS.height = "50%";
  modalCSS.maxHeight = "240px";
  useEffect(() => {}, []);
  if (data?.itemData?.err === 1) {
    modalCSS.height = "170px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {data.itemData.err_msg}</div>
    );
  } else if (data?.itemData?.status === "inprocess") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    //console.log("Remove=", dara.itemData);
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );

    content = (
      <div className="modal-content-outer">
        <div key="modal-content-inner" className="modal-content-inner">
          <span
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "18px",
              marginBottom: "25px",
              marginTop: "20px",
            }}
          >
            Are you sure to bulk remove?
          </span>
          <Button
            className=""
            id="btn-confirm-remove-recip"
            node="button"
            waves="light"
            small={true}
            style={{
              width: "100px",
              borderRadius: "20px",
              margin: "0 auto",
              display: "block",
            }}
            onClick={handleEvents.RemoveItems.OnSubmit}
          >
            Confirm
          </Button>
        </div>
        <div key="modal-loading" className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
              },
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="recip-modal-remove"
      open={data.isOpen}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: handleEvents.BtnOpenRemove.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
    </Modal>
  );
}
